import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { toast } from 'sonner';

import type { ApiError } from '@/core/api';
import * as api from './api';
import type { LessonInput } from './api';

export const lessonKeys = {
  all: ['lessons'] as const,
  lists: () => [...lessonKeys.all, 'list'] as const,
  list: (p: api.LessonListParams) => [...lessonKeys.lists(), p] as const,
};

export function useLessons(params: api.LessonListParams = {}) {
  return useQuery({
    queryKey: lessonKeys.list(params),
    queryFn: () => api.listLessons(params),
    placeholderData: keepPreviousData,
  });
}

export function useCreateLesson() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: LessonInput) => api.createLesson(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: lessonKeys.lists() });
      toast.success('Material added');
    },
    onError: (err: ApiError) => {
      if (!err.fieldErrors) toast.error(err.message);
    },
  });
}

export function useDeleteLesson() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.deleteLesson(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: lessonKeys.lists() });
      toast.success('Material deleted');
    },
    onError: (err: ApiError) => toast.error(err.message),
  });
}
